







































import { defineComponent, computed } from "@vue/composition-api";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { $t } from "@/lib/i18nHelpers";
import { timeAgo } from "@/lib/time";
import { BaseMenuItem } from "@/types";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import MessagePreview from "@/components/MessagePreview";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "MessageThreadView",
  components: { BaseMenu, MessagePreview, BasePage, BaseIcon, PageTitle, BaseAvatar, BaseButton },
  props: {
    messageThread: { type: Object as () => MessageThread, required: true },
    canManageThreads: { type: Boolean, required: true },
    authUserId: { type: String, required: true },
    isBlocked: { type: Boolean, default: false },
    subscriberCost: { type: Number, required: true },
  },
  setup(props) {
    const user = computed<UserPublicData | undefined>(() => {
      return (
        props.messageThread?.users.find(i => i.id !== props.authUserId) ??
        props.messageThread?.users.find(i => i.id === props.authUserId)
      );
    });

    const to = computed<{ name: string; params: { userId: string } }>(() => {
      const userId = props.messageThread.userIds.find(i => i !== props.authUserId) || props.authUserId;
      return { name: "messages", params: { userId } };
    });
    const screenName = computed(() => user.value?.screenName ?? "");

    const timeData = computed(() => timeAgo(props.messageThread.updatedTime));

    const menuItems = computed<BaseMenuItem[]>(() => {
      const items: BaseMenuItem[] = [
        {
          name: "threadHide",
          text: $t("Hide"),
        },
      ];
      if (props.canManageThreads) {
        items.push({
          name: "threadDelete",
          text: $t("Delete"),
          class: "negative",
        });
      }
      return items;
    });

    return { user, to, screenName, timeData, menuItems };
  },
});
